/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { AmountEuroCents } from "./AmountEuroCents";
import * as t from "io-ts";

/**
 * Transaction outcome info returned when querying for an existing transaction outcome status. The field totalAmount, if present, is intended as the total amount paid for the transaction in eurocents fees excluded. Fees too, if present, is in eurocents
 */

// required attributes
const TransactionOutcomeInfoR = t.interface({
  outcome: t.number,

  isFinalStatus: t.boolean
});

// optional attributes
const TransactionOutcomeInfoO = t.partial({
  totalAmount: AmountEuroCents,

  fees: AmountEuroCents
});

export const TransactionOutcomeInfo = t.intersection(
  [TransactionOutcomeInfoR, TransactionOutcomeInfoO],
  "TransactionOutcomeInfo"
);

export type TransactionOutcomeInfo = t.TypeOf<typeof TransactionOutcomeInfo>;
